
import styled from 'styled-components';
import React from 'react';
import ActionsContext from '../ActionsContextV2';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Select from 'react-select';

const Container = styled.div`
    padding-left:30px;
    width:200px;
`;

const useStyles = makeStyles((theme) => ({
    margin: {
      margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
        background:'white'
    },
  }));

  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: state.isFocused ? "rgb(61, 122, 150);" : null,
      boxShadow: 'none',
      border: state.isFocused  ? '1.5px solid lightgray' : '1px solid lightgray', // default border color
      "&:hover": {
        borderColor: state.isFocused ? "rgb(61, 122, 150);" : "black"
      }
    }),
    menu: base => ({
      ...base,
      borderRadius: 0,
      marginTop: 0
    }),
    menuList: base => ({
      ...base,
      padding: 0,
      maxHeight : window.innerHeight - 300
    })
  };

  
  
const ActionFormComplianceFilterV2 = () => {
  const classes = useStyles();
  const context = React.useContext(ActionsContext);

  const complianceSourceList = [];
  complianceSourceList.push('All');
  complianceSourceList.push('Yes');
  complianceSourceList.push('No');
  complianceSourceList.push('N/A');
  complianceSourceList.push('None');

  let {pendingActions,approvedActions,currentStepIndex = 0} = context.actionsRedux.selectedProjectFunctionDetails;

  // if category filter exists then apply that
  if (context.categoryFilterText !== "" && context.categoryFilterText !== "All") {
    pendingActions = pendingActions.filter((pa) => { return  (pa.categoryName && pa.categoryName === context.categoryFilterText)});
    approvedActions = approvedActions.filter((aa) => { return  (aa.categoryName && aa.categoryName === context.categoryFilterText)});
  }
  
  // filter count for each compliance to display next to it
  let filteredCompliance = [];
  
  complianceSourceList.forEach(function (compliance, index) {
    let filterValue = compliance === 'None' ? null : compliance;
    filteredCompliance = context.pendingCompletedTab === 0 ? pendingActions.filter((pa) => { return  (pa.applicability === filterValue && pa.currentStepIndex === currentStepIndex);}) :
      approvedActions.filter((pa) => { return  (pa.applicability === filterValue );});
    complianceSourceList[index] = (compliance === 'All') ? compliance : compliance + ' (' + filteredCompliance.length + ')';
  });

  const buildComplianceData = compliance => {
    return { label: compliance, value : compliance }
  }

  let complianceListToDisplay = complianceSourceList.map(buildComplianceData);
  let complianceList = [
    {
        label: "Compliance",
        options: complianceListToDisplay
    },
  ]

  return <Container>
    <Select
      classes={classes}
      styles={customStyles}
      options={complianceList}
      onChange={(selectedCompliance) => {
        const compliance = selectedCompliance.value.substring(0, selectedCompliance.value.indexOf( ' (' ));
        context.setComplianceFilterText(compliance);
        context.showSnackBarMessage("Filter Successfully Applied.",null,4000);
      }}
      placeholder="Compliance"
      
    />
  </Container>
}

export default  ActionFormComplianceFilterV2;